import * as React from 'react';
import { SemanticIcon, SemanticIconName, SemanticIconSize } from '../../Icons';
import { jsx as _jsx } from "react/jsx-runtime";
export const InlineEditCheckboxIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    value
  } = _ref;
  return /*#__PURE__*/_jsx(SemanticIcon, {
    semanticName: value ? SemanticIconName.Yes : SemanticIconName.No,
    size: SemanticIconSize.Medium
  });
});